import { render, staticRenderFns } from "./VModelObject.vue?vue&type=template&id=bb966742"
import script from "./VModelObject.vue?vue&type=script&lang=js"
export * from "./VModelObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports